// extracted by mini-css-extract-plugin
export default {"root":"CustomFormikSelect_root__JcdjK","errorMessage":"CustomFormikSelect_errorMessage__IQAuR"};